import { globalState } from '../global-state';

export interface NounContainer {
  [key: string]: Noun;
}

export function nounContainer(): NounContainer {
  const state = globalState();
  if (!state.nounContainer) {
    state.nounContainer = {};
  }
  return state.nounContainer as NounContainer;
}

export type EventNounGet = () => string;
export interface Noun {
  single: EventNounGet;
  plural: EventNounGet;
}
